/* Shopify API overwrites. */

Shopify.myFormatMoney = function (cents, format) {
  var value = '';
  var patt = /\{\s*(\w+)\s*\}/;
  var formatString = (format || this.money_format);
  switch (formatString.match(patt)[1]) {
  case 'amount':
    value = floatToString(cents / 100.0, 2);
    break;
  case 'amount_no_decimals':
    value = floatToString(cents / 100.0, 0);
    break;
  case 'amount_with_comma_separator':
    value = floatToString(cents / 100.0, 2).replace(/\./, ',');
    break;
  }
  return formatString.replace(patt, value);
};

Shopify.clearCart = function () {
  if (confirm("Are you sure?  This will remove all the items from your shopping cart.")) {
    Shopify.clear();

    inputs = $$(".variant-row input");
    for (var index = 0, len = inputs.length; index < len; ++index) {
      var input = inputs[index];
      input.value = "";
    }
    rows = $$("tr.ordered");
    for (var index = 0, len = rows.length; index < len; ++index) {
      var row = rows[index];
      // Your code working on item here...
      row.removeClassName("ordered");
    }
  }
};



/* We overwrite this function to prevent it from alerting on improper ajax responses */
Shopify.params = function (method, parameters, callback) {
  var hash = {
    method: (method || 'post'),
    parameters: (parameters || ''),
    evalScripts: false,
    asynchronous: true,
    requestHeaders: {
      'If-Modified-Since': "Sat, 1 Jan 2000 00:00:00 GMT"
    }
  };
  if (callback == null) {
    callback = this.onDebug.bind(this);
  }
  // Common Code Patch
  //hash.onSuccess = function(t) {
  hash.onComplete = function (t) {
    try {
      callback($(eval('(' + t.responseText + ')')));
    } catch (e) { //alert("API Error: " + e + "\n\n"+t.responseText); 
    };
  }.bind(this);
  hash.onFailure = function (t) {
    try {
      this.onError($(eval('(' + t.responseText + ')')));
    } catch (e) { //alert("API Error: " + e + "\n\n"+t.responseText); 
    };
  }.bind(this);

  return hash;
};

/* Post-request handlers 
 * onItemRemoved, onChangeItem, onItemAdded
 *******************************************/

Shopify.onItemRemoved = function (variant, cart) {
  $('message').show().update('Removed item from cart').fade({
    delay: 1.5
  });
  try {
    $(variant + '_order_quantity').value = '';
    $(variant + '_current_order_quantity').value = '';
    $(variant + '_order_weight').value = '';
    $(variant + '_order_cost').value = '';
    $(variant + '_variant-row').removeClassName('removing');
  } catch (e) {
    // couldn't cleanup the variant row, probably not on this page...
  }
  Shopify.onCartUpdate(cart);
};

Shopify.onChangeItem = function (variant, cart) {
  $('message').show().update('Cart updated.').fade({
    delay: 1.5
  });
  var quantity, grams, line_price;
  for (i = 0; i < cart.items.length; i++) {
    if (cart.items[i].variant_id == variant) {
      quantity = cart.items[i].quantity;
      grams = cart.items[i].grams;
      line_price = cart.items[i].line_price;
    }
  }
  if (quantity) {
    $(variant + '_order_quantity').value = quantity;
    $(variant + '_current_order_quantity').value = quantity;
    $(variant + '_order_weight').value = (quantity * grams) / 1000;
    $(variant + '_order_cost').value = Shopify.myFormatMoney(line_price, '{amount}');
    $(variant + '_variant-row').removeClassName('changing');
    $(variant + '_variant-row').addClassName('ordered');
  }
  Shopify.onCartUpdate(cart);
};

Shopify.onItemAdded = function (item) {
  $('message').show().update('Item added to cart.').fade({
    delay: 1.5
  });

  Shopify.getCart();

  try {
    $(item.variant_id + '_order_quantity').value = item.quantity;
    $(item.variant_id + '_current_order_quantity').value = item.quantity;
    $(item.variant_id + '_order_weight').value = (item.quantity * item.grams) / 1000;
    $(item.variant_id + '_order_cost').value = Shopify.myFormatMoney(item.line_price, '{amount}');
    $(item.variant_id + '_variant-row').removeClassName('changing');
    $(item.variant_id + '_variant-row').addClassName('ordered');
  } catch (e) {
    //console.log("couldn't update variant TR");
  }
};

Shopify.onError = function (data) {
  var msg = data.status === 422 ? 'We are temporarily out of stock of this item.' : msg.description;
  $('message').show().update(msg).fade({
    delay: 5
  });

  Shopify.getCart();
};

Shopify.getCartForVariant = function (variant, callback) {
  new Ajax.Request("/cart.js", this.params('get', null, (callback || this.onCartUpdate.bind(this, variant))));
};


/* Requesting functions - changeItem, addItem, removeItem 
 *********************************************************/

Shopify.changeItem = function (variant_id, quantity, callback) {
  $('message').show().update('Updating item in cart...');
  try {
    $(variant_id + '_variant-row').removeClassName('ordered');
    $(variant_id + '_variant-row').addClassName('changing');
  } catch (e) {
    // couldn't update variant row.
  }
  new Ajax.Request("/cart/change.js", this.params('post', 'quantity=' + quantity + '&id=' + variant_id, callback || this.onChangeItem.bind(this, variant_id)));
};

Shopify.removeItem = function (variant_id, callback) {
  $('message').show().update('Removing item from cart...');
  try {
    $(variant_id + '_variant-row').removeClassName('ordered');
    $(variant_id + '_variant-row').addClassName('removing');
  } catch (e) {
    // couldn't update variant row.
  }
  new Ajax.Request("/cart/change.js", this.params('post', 'quantity=0&id=' + variant_id, callback || this.onItemRemoved.bind(this, variant_id)));
};

Shopify.addItem = function (variant_id, quantity, callback) {
  $('message').show().update('Adding item to cart...');
  var quantity = quantity || 1;
  try {
    $(variant_id + '_variant-row').removeClassName('ordered');
    $(variant_id + '_variant-row').addClassName('changing');
  } catch (e) {
    //console.log("couldn't update variant row tr");
  }
  new Ajax.Request("/cart/add.js", this.params('post', 'quantity=' + quantity + '&id=' + variant_id, callback || this.onItemAdded.bind(this)));
};

Shopify.debounce = function (func, threshold, execAsap) {
  var timeout;
  return function debounced() {
    var obj = this,
      args = arguments;

    function delayed() {
      if (!execAsap)
        func.apply(obj, args);
      timeout = null;
    };
    if (timeout)
      clearTimeout(timeout);
    else if (execAsap)
      func.apply(obj, args);
    timeout = setTimeout(delayed, threshold || 100);
  };
};

/* Called when the value of a variant input is adjusted.  Determines which AJAX call to make. */
Shopify.alterItemNonDebounced = function (variant_id, current_quantity, new_quantity) {
  // sanitise the values

  current_quantity = current_quantity.strip() || 0;
  new_quantity = new_quantity.strip();

  // add, change or remove items.
  if (current_quantity > 0) {
    // item must be in the cart, so we are either changing or removing
    if (new_quantity == 0) {
      // remove item
      this.removeItem(variant_id);
    } else {
      // change item
      this.changeItem(variant_id, new_quantity);
    }
  } else {
    if (new_quantity > 0) {
      console.log('addItem ' + variant_id + ' at quantity ' + new_quantity);
      this.addItem(variant_id, new_quantity, function (item) {
        if (item.id === undefined) {
          $(variant_id + '_variant-row').removeClassName('changing');

          return false;
        }

        $('message').show().update('Item added to cart.').fade({
          delay: 1.5
        });

        Shopify.getCart();

        try {
          $(variant_id + '_order_quantity').value = item.quantity;
          $(variant_id + '_current_order_quantity').value = item.quantity;
          $(variant_id + '_order_weight').value = (item.quantity * item.grams) / 1000;
          $(variant_id + '_order_cost').value = Shopify.myFormatMoney(item.line_price, '{amount}');
          $(variant_id + '_variant-row').removeClassName('changing');
          $(variant_id + '_variant-row').addClassName('ordered');
        } catch (e) {
          //console.log("couldn't update variant TR");
        }
      });
    }
  }
};

Shopify.alterItem = Shopify.debounce(function () {
  window.onbeforeunload = function () {
    return confirm('You cart has not been updated yet.');
  };

  Shopify.alterItemNonDebounced.apply(this, arguments);
}, 250, false);

/* Callback for updateCart, repopulates the sidebar cart. */
Shopify.onCartUpdate = function (cart) {
  $('cart-total-price').update(Shopify.myFormatMoney(cart.total_price, '${amount}'));
  $$('#cartcontents .sidebar-ribbon.yourcart')[0].show();

  cart_ul = $('cartlist');
  cart_ul.update('');
  for (var i = 0; i < cart.items.length; i++) {
    var variant = cart.items[i].variant_id;
    if ($(variant + '_order_weight')) {
      $(variant + '_order_weight').value = (cart.items[i].quantity * cart.items[i].grams) / 1000;
    }
    Element.insert(cart_ul, {
      'bottom': '<li class="cart_item" id="cart_item_' + i + '"><span class="cart_product_name">' + cart.items[i].title.truncate(25) + '<a class="remove_link" onclick="Shopify.removeItem(\'' + cart.items[i].variant_id + '\')">[x]</a></span></li>'
    });
  }
  if (cart.items.length == 0) {
    Element.insert(cart_ul, {
      'bottom': '<li><span>Your cart is empty.</span></li>'
    });
  } else {
    Element.insert(cart_ul, {
      'bottom': '<li><a id="clear-cart-button" onclick="Shopify.clearCart();">Clear Cart</a></li>'
    });
  }
};